module.exports = __webpack_public_path__ + "img/joechang@2x.a60d823e.png";